import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SendEmailComponent} from './send-email.component';
import {CardModule} from "../../../../../core/component/card/card.module";
import {EmailContentFormModule} from "../email-content-form/email-content-form.module";
import {FormFieldModule} from "../../../../../core/component/form-field/form-field.module";
import {
    LovValuesSelectFilterModule
} from "../../../../../common/lov/lov-value/api/component/lov-values-select-filter/lov-values-select-filter.module";
import {
    LovValueSelectFilterModule
} from "../../../../../common/lov/lov-value/api/component/lov-value-select-filter/lov-value-select-filter.module";
import {DateTimePickerModule} from "../../../../../../components/common/datetime-picker/date-time-picker.module";
import {SelectModule} from "../../../../../../components/common/select/select.module";
import {ButtonModule} from "../../../../../core/component/button/button.module";
import {ActionDefaultModule} from "../../../../../core/component/action-default/action-default.module";
import {SendEmailTriggerFormComponent} from "../send-email-trigger-form/send-email-trigger-form.component";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        FormsModule,
        ReactiveFormsModule,
        CardModule,
        EmailContentFormModule,
        FormFieldModule,
        LovValuesSelectFilterModule,
        LovValueSelectFilterModule,
        DateTimePickerModule,
        SelectModule,
        ButtonModule,
        ActionDefaultModule,
        SendEmailTriggerFormComponent,
    ],
    declarations: [
        SendEmailComponent,
    ],
    exports: [
        SendEmailComponent
    ],
})
export class SendEmailModule {
}
